import type { TypographyVariantsOptions } from '@mui/material/styles';

const fontFamily = 'PorscheFont, sans-serif';

export const typography: TypographyVariantsOptions = {
  fontFamily,
  fontWeightLight: 200,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
};
